<template>
	<div class="login">
		<div class="w">
			<div class="flex login-box">
				<div class="login-left">
					<div class="login-left-box">
						<div class="login_logo flex justify-content" @click="jumpClick">
							<img v-if="$functions.isFoTon()" src="../assets/foton/foton100black.png" alt=""  />
							<img v-else src="../assets/logo2.png" alt=""  />
						</div>
						<div class="login-tab flex" v-if="titleShow == 1">
							<ul class="flex space-between">
								<li @click="tab(1)" :class="{ 'active-tab': isActive == 1 ? 'active-tab' : '' }">{{ $t('login.accountLogin') }}</li>
								<li @click="tab(2)" :class="{ 'active-tab': isActive == 2 ? 'active-tab' : '' }">{{ $t('login.quickLogin') }}</li>
							</ul>
						</div>
						<div class="login-tab flex justify-content" v-if="titleShow == 3"><p class="flex justify-content">{{ $t('login.userRegistration') }}</p></div>
						<div class="login-tab flex justify-content" v-if="titleShow == 4"><p class="flex justify-content">{{ $t('login.changePassword') }}</p></div>
						<div class="flex column align-items login-inpu-box" v-show="loginBox == 1" @enter="keydown($event)">
							<el-form :model="accountForm" :rules="accountRules" ref="accountForm" class="demo-ruleForm" style="width: 100%">
								<el-form-item prop="username" style="margin-bottom: 6%">
									<!--账号登录-->
									<i
										class="icon iconfont icon-yonghu"
										style="
                      color: #d7dee3;
                      position: absolute;
                      left: 8px;
                      z-index: 11;
                    "
									></i>
									<el-input v-model.trim="accountForm.username" :placeholder="$t('main.enterOneUserName')"></el-input>
								</el-form-item>
								<el-form-item prop="password">
									<i
										class="icon iconfont icon-mima1"
										style="
                      color: #d7dee3;
                      position: absolute;
                      left: 8px;
                      z-index: 11;
                    "
									></i>
									<el-input type="password" v-model.trim="accountForm.password" autocomplete="off" :placeholder="$t('main.pleaseInputPassword')"></el-input>
								</el-form-item>
								<!-- <p> -->
								<div class="lang-box">
									<!-- 语言切换 -->
									<!-- <el-select 
										v-model="languageValue"
										@change="langChange"
									>
										<el-option
											v-for="item in languageList"
											:key="item.value"
											:label="item.label"
											:value="item.value">
										</el-option>
									</el-select> -->
									<span
										style="
											color: #0080ff;
											float: left;
											font-size: 12px;
											cursor: pointer;
										"
										@click="forgetpassword(4)"
									>
											{{ $t('login.forgotPassword') }}?
									</span>
								</div>
								<!-- <span
									style="
				    color: #0080ff;
				    float: right;
				    font-size: 12px;
				    maegin-top: -10px;
				    cursor: pointer;
				  "
									@click="registerShow(3)"
								>
									立即注册?
								</span> -->

								<!-- </p> -->
							 <el-form-item style="margin-top: 9%">
									<el-button type="primary" :loading="loginLoading" style="width: 100%" id="login_btn" @click="login">{{$t('login.login')}}</el-button>
									<!-- <div class="flex justify-content align-items" style="margin-top: 4%; cursor: pointer">
										<div class="login-line"></div>
										<div class="register">第三方登录</div>
										<div class="login-line"></div>
									</div>
									<div class="thirdParty">
										<span class="thirdParty_QQ" @click="thirdParty_QQ">
											<svg class="icon" aria-hidden="true"><use xlink:href="#wjpc-icon-QQ"></use></svg>
										</span>
										<span class="thirdParty_WX" @click="thirdParty_WX">
											<svg class="icon" aria-hidden="true">
												<use
													xlink:href="#wjpc-icon-weixin
"
												></use>
											</svg>
										</span>
									</div> -->
								</el-form-item>
							</el-form>
						</div>
						<div class="flex column align-items login-inpu-box" v-show="loginBox == 2">
							<el-form :model="fastForm" :rules="fastRules" ref="fastForm" class="demo-ruleForm" style="width: 100%">
								<el-form-item prop="phone" style="margin-bottom: 6%">
									<!-- 快速登录-->
									<i
										class="icon iconfont icon-yonghu"
										style="
											color: #d7dee3;
											position: absolute;
											left: 8px;
											z-index: 11;
										"
									></i>
									<el-input v-model="fastForm.phone" :placeholder="$t('main.pleaseEnterYourPhoneNumber')"></el-input>
								</el-form-item>
								<el-form-item prop="verificationcode">
									<div class="flex">
										<i
											class="icon iconfont icon-yanzhengma"
											style="
												color: #d7dee3;
												position: absolute;
												left: 8px;
												z-index: 11;
											"
										></i>
										<el-input v-model="fastForm.verificationcode" :placeholder="$t('login.pleaseEnterTheVerificationCode')" prefix-icon="iconfont"></el-input>
										<el-button plain style="margin-left: 10px" v-if="codeStatus == 1" @click="getCode(1)">{{$t('login.obtainVerificationCode')}}</el-button>
										<el-button plain style="margin-left: 10px; cursor: auto" v-if="codeStatus == 2">{{ countDownNum }}s</el-button>
									</div>
								</el-form-item>
								<el-form-item style="margin-top: 9%">
									<el-button type="primary" style="width: 100%" @click="phoneLogin">{{$t('login.login')}}</el-button>
									<!-- <div class="flex justify-content align-items" style="margin-top: 4%; cursor: pointer" @click="registerShow(3)">
										<div class="login-line"></div>
										<div class="register">立即注册</div>
										<div class="login-line"></div>
									</div> -->
								</el-form-item>
							</el-form>
						</div>
						<div class="flex column align-items login-inpu-box" v-show="loginBox == 3">
							<el-form :model="registerForm" :rules="registerRules" ref="registerForm" class="demo-ruleForm" style="width: 100%">
								<el-form-item prop="phone" style="margin-bottom: 6%">
									<i
										class="icon iconfont icon-yonghu"
										style="
											color: #d7dee3;
											position: absolute;
											left: 8px;
											z-index: 11;
										"
									></i>
									<el-input v-model="registerForm.phone" :placeholder="$t('main.pleaseEnterYourPhoneNumber')"></el-input>
								</el-form-item>
								<el-form-item prop="code" style="margin-bottom: 6%">
									<div class="flex">
										<i
											class="icon iconfont icon-yanzhengma"
											style="
												color: #d7dee3;
												position: absolute;
												left: 8px;
												z-index: 11;
											"
										></i>
										<el-input v-model="registerForm.code" :placeholder="$t('login.pleaseEnterTheVerificationCode')"></el-input>
										<el-button plain style="margin-left: 10px" v-if="codeStatus == 1" @click="getCode(2)">{{$t('login.obtainVerificationCode')}}</el-button>
										<el-button plain style="margin-left: 10px" v-if="codeStatus == 2">{{ countDownNum }}s</el-button>
									</div>
								</el-form-item>
								<el-form-item prop="password">
									<i
										class="icon iconfont icon-mima1"
										style="
											color: #d7dee3;
											position: absolute;
											left: 8px;
											z-index: 11;
										"
									></i>
									<el-input type="password" v-model="registerForm.password" autocomplete="off" :placeholder="$t('main.pleaseInputPassword')"></el-input>
								</el-form-item>
								<el-form-item style="margin-top: 9%">
									<el-button type="primary" style="width: 100%" @click="register">{{$t('login.registerNow')}}</el-button>
									<div class="flex justify-content align-items" style="margin-top: 4%; cursor: pointer" @click="registerShow(1)">
										<div class="login-line"></div>
										<div class="register">{{$t('login.returnToLogin')}}</div>
										<div class="login-line"></div>
									</div>
								</el-form-item>
							</el-form>
						</div>

						<div class="flex column align-items login-inpu-box" v-show="loginBox == 4">
							<el-form :model="forgetForm" :rules="forgetRules" res="forgetForm" class="demo-ruleForm" style="width: 100%">
								<el-form-item prop="phone" style="margin-bottom: 6%">
									<i
										class="icon iconfont icon-yonghu"
										style="
											color: #d7dee3;
											position: absolute;
											left: 8px;
											z-index: 11;
                    					"
									></i>
									<!--账号登录-->
									<el-input v-model="forgetForm.phone" :placeholder="$t('main.pleaseEnterYourPhoneNumber')"></el-input>
								</el-form-item>
								<el-form-item prop="code" style="margin-bottom: 6%">
									<div class="flex">
										<i
											class="icon iconfont icon-yanzhengma"
											style="
												color: #d7dee3;
												position: absolute;
												left: 8px;
												z-index: 11;
											"
										></i>
										<el-input v-model="forgetForm.code" :placeholder="$t('login.pleaseEnterTheVerificationCode')" prefix-icon="iconfont icon-verify-fill"></el-input>
										<el-button plain style="margin-left: 10px" v-if="codeStatus == 1" @click="getCode(3)">{{$t('login.obtainVerificationCode')}}</el-button>
										<el-button plain style="margin-left: 10px" v-if="codeStatus == 2">{{ countDownNum }}s</el-button>
									</div>
								</el-form-item>

								<el-form-item prop="newPassword">
									<i
										class="icon iconfont icon-mima1"
										style="
											color: #d7dee3;
											position: absolute;
											left: 8px;
											z-index: 11;
										"
									></i>
									<el-input type="password" v-model="forgetForm.newPassword" autocomplete="off" :placeholder="$t('main.pleaseInputPassword')"></el-input>
								</el-form-item>
								<el-form-item style="margin-top: 9%">
									<el-button type="primary" style="width: 100%" @click="forgetPS">{{$t('main.ok')}}</el-button>
									<div class="flex justify-content align-items" style="margin-top: 4%; cursor: pointer" @click="registerShow(1)">
										<div class="login-line"></div>
										<div class="register">{{$t('login.returnToLogin')}}</div>
										<div class="login-line"></div>
									</div>
								</el-form-item>
							</el-form>
						</div>
					</div>
				</div>
				<div class="login-right">
					<!-- <img src="../assets/login_bg_img.png" alt="" class="right-img" /> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import i18n from '@/i18n'
export default {
	name: 'Login',
	data() {
		return {
			loginLoading: false,
			loginBox: '',
			isActive: 1,
			titleShow: 1,
			countDownNum: 60,
			codeStatus: 1,
			accountForm: {
				password: '',
				username: ''
			},
			fastForm: {
				phone: '',
				verificationcode: ''
			},
			registerForm: {
				phone: '',
				code: '',
				password: ''
			},
			forgetForm: {
				phone: '',
				code: '',
				newPassword: ''
			},
			accountRules: {},
			fastRules: {},
			registerRules: {},
			forgetRules: {},
			languageValue: this.$defaultLang,
			languageList: [
				{
					value: 'zh-CN',
					label: '简体中文'
				},
				{
					value: 'zh-TW',
					label: '繁体中文'
				},
				{
					value: 'en-US',
					label: 'English'
				},
				{
					value: 'ms-MY',
					label: 'Malay'
				},
				
			]
		};
	},
	created() {
		// console.log('window.localStorage.getItem(lang) :>> ', window.localStorage.getItem('lang'));
		this.languageValue = window.localStorage.getItem('lang') || this.$defaultLang
		// console.log('this.languageValue :>> ', this.languageValue);
		this.setAccountForm()
		var id = '';
		if (this.$route.query.id) {
			id = this.$route.query.id;
		} else {
			id = 1;
		}
		this.loginBox = id;
		this.titleShow = id;
		let that = this;
		document.onkeypress = function(e) {
			var keycode = document.all ? event.keyCode : e.which;
			// console.log(keycode);
			if (keycode == 13) {
				that.login(); // 登录方法名
				return false;
			}
		};
	},
	methods: {
		language() {
			return window.localStorage.getItem('lang') || this.$defaultLang
		},
		// 语言切换
		langChange() {
			// 切换语言前 清除表单验证
			this.$nextTick(()=>{
				this.$refs.accountForm.resetFields();
			});
			
			this.$i18n.locale = this.languageValue
			localStorage.setItem('lang', this.languageValue)
			this.setAccountForm()
		},
		// 表单重新赋值语言
		setAccountForm(){
			this.accountRules = {
				username: [{ required: true, message: this.$t('main.enterOneUserName'), trigger: 'blur' }],
				password: [{ required: true, message: this.$t('main.pleaseInputPassword'), trigger: 'blur' }]
			}
			this.fastRules = {
				phone: [{ required: true, message: this.$t('main.pleaseEnterYourPhoneNumber'), trigger: 'blur' }],
				verificationcode: [{ required: true, message: this.$t('login.pleaseEnterTheVerificationCode'), trigger: 'blur' }]
			}
			this.registerRules = {
				phone: [{ required: true, message: this.$t('main.pleaseEnterYourPhoneNumber'), trigger: 'blur' }],
				code: [{ required: true, message: this.$t('login.pleaseEnterTheVerificationCode'), trigger: 'blur' }],
				password: [{ required: true, message: this.$t('main.pleaseInputPassword'), trigger: 'blur' }]
			}
			this.forgetRules = {
				phone: [{ required: true, message: this.$t('main.pleaseEnterYourPhoneNumber'), trigger: 'blur' }],
				code: [{ required: true, message: this.$t('login.pleaseEnterTheVerificationCode'), trigger: 'blur' }],
				newPassword: [{ reuired: true, message: this.$t('login.pleaseEnterNewPassword'), trigger: 'blur' }]
			}
		},
		// 第三方登录
		thirdParty_QQ() {
			this.$axios({
				method: 'GET',
				url: this.$config.service.qqLogin,
				data: {},
				headers:{
					'Accept-Language': this.language(),
				},
			})
				.then(succeed => {
					console.log(succeed.data.resultBody)
					window.location.href = succeed.data.resultBody;
				})
				.catch(error => {
					console.log(error);
				});
		},
		thirdParty_WX() {
			this.$axios({
				method: 'GET',
				url: this.$config.service.wechatLogin,
				data: {},
				headers:{
					'Accept-Language': this.language(),
				},
			})
				.then(succeed => {
					console.log(succeed.data.resultBody)
					window.location.href = succeed.data.resultBody;
				})
				.catch(error => {
					console.log(error);
				});
		},
		keydown(event) {
			console.log(event);
			if (event.keyCode == 13) {
				console.log(111111);
			}
		},
		tab(type) {
			this.loginBox = type;
			this.isActive = type;
			this.titleShow = 1;
			this.codeStatus = 1;
			this.accountForm.username = '';
			this.accountForm.password = '';
			this.fastForm.phone = '';
			this.fastForm.verificationcode = '';
			this.registerForm.phone = '';
			this.registerForm.password = '';
			this.registerForm.code = '';
		},
		registerShow(type) {
			this.titleShow = type;
			this.codeStatus = 1;
			if (type == 1) {
				this.loginBox = 1;
				this.isActive = 1;
			} else {
				this.loginBox = 3;
			}
			this.accountForm.username = '';
			this.accountForm.password = '';
			this.fastForm.phone = '';
			this.fastForm.verificationcode = '';
			this.registerForm.phone = '';
			this.registerForm.password = '';
			this.registerForm.code = '';
		},
		forgetpassword(type) {
			this.titleShow = type;
			if (type == 4) {
				this.loginBox = 4;
			}
		},
		forgetPS() {
			this.$axios({
				method: 'POST',
				url: this.$config.service.changePassword,
				data: {
					phone: this.forgetForm.phone,
					code: this.forgetForm.code,
					password: this.forgetForm.newPassword
				},
				headers:{
					'Accept-Language': this.language(),
				},
			})
				.then(response => {
					if (response.data.code == 0) {
						this.loginBox = 1;
						this.titleShow = 1;
					} else {
						this.$message.error(response.data.message);
					}
				})
				.catch(error => {
					console.log(error);
				});
		},
		//定时器
		countDown() {
			let that = this;
			let countDownNum = that.countDownNum;
			that.timer = setInterval(function() {
				countDownNum--;
				that.countDownNum = countDownNum;
				if (countDownNum == 0) {
					clearInterval(that.timer);
					that.codeStatus = 1;
					that.countDownNum = '60';
				}
			}, 1000);
		},
		//获取验证码
		getCode(type) {
			console.log('type',type)
			var phone = '';
			var register = '';
			if (type == 1) {
				phone = this.fastForm.phone;
				register = '';
			} else if (type == 2) {
				phone = this.registerForm.phone;
				register = 'register';
			} else if (type == 3) {
				phone = this.forgetForm.phone;
				register = '';
			}
			if (!/^1[3456789]\d{9}$/.test(phone)) {
				this.$message.error(this.$t('main.PleaseEnterValidPhoneNumber'));
			} else {
				this.$axios({
					method: 'POST',
					url: this.$config.service.sendPhoneCode,
					data: {
						phone: phone,
						state: register
					},
					headers:{
						'Accept-Language': this.language(),
					},
				})
					.then(response => {
						if (response.data.code == 0) {
							this.$message.success(this.$t('main.SMSSentSuccessfully'));
							this.codeStatus = 2;
							this.countDown();
							
						} else {
							this.$message.error(response.data.message);
						}
					})
					.catch(error => {
						console.log(error);
					});
			}
		},
		//注册
		register() {
			this.$refs['registerForm'].validate(valid => {
				if (!valid) {
					return false;
				}
				this.$axios({
					method: 'POST',
					url: this.$config.service.userRegister,
					data: this.registerForm,
					headers:{
						'Accept-Language': this.language(),
					},
				})
					.then(response => {
						if (response.data.code == 0) {
							this.$message.success(this.$t('login.loginWasSuccessful'));
							this.titleShow = 1;
							this.loginBox = 1;
							this.isActive = 1;
						} else {
							this.$message.error(response.data.message);
						}
					})
					.catch(error => {
						console.log(error);
					});
			});
		},
		//手机登录
		phoneLogin() {
			let _that = this;
			_that.$refs['fastForm'].validate(valid => {
				if (!valid) {
					console.log('111111');
					return false;
				}
				_that
					.$axios({
						method: 'POST',
						url: _that.$config.service.phoneLogin,
						data: this.fastForm,
						headers:{
							'Accept-Language': this.language(),
						},
					})
					.then(response => {
						if (response.data.code == 0) {
							let userInfo = JSON.stringify(response.data.resultBody);
							window.localStorage.setItem('userInfo', userInfo);
							window.localStorage.setItem('token', response.data.resultBody.token);
							this.$message.success(this.$t('login.LoginSucceeded'));
							this.$router.push({ path: '/my' });
							// this.$router.push(this.$route.query.redirect)
						} else {
							this.$message.error(response.data.message);
						}
					})
					.catch(error => {
						console.log(error);
					});
			});
		},
		jumpClick() {
			this.$router.push({ path: '/' });
		},
		//密码登录
		login() {
			this.loginLoading = true
			let _that = this;
			this.$refs['accountForm'].validate(valid => {
				if (!valid) {
					this.loginLoading = false
					return false;
				}
				console.log( this.accountForm)
				_that
					.$axios({
						method: 'POST',
						url: _that.$config.service.login,
						data: this.accountForm,
						headers:{
							'Accept-Language': this.language(),
						},
					})
					.then(response => {
						this.loginLoading = false
						if (response.data.code == 0) {
							let userInfo = JSON.stringify(response.data.resultBody);
							window.localStorage.setItem('userInfo', userInfo);
							window.localStorage.setItem('token', response.data.resultBody.token);
							this.$message.success(this.$t('login.LoginSucceeded'));
							if (this.$route.query.redirect != undefined) {
								this.$router.push(this.$route.query.redirect);
							} else {
								this.$router.push({ path: '/my' });
							}
							// this.$router.push(this.$route.query.redirect)
							console.log('输出路径', this.$route.query.redirect);
							// this.$router.push({path:'/'})
						} else {
							this.$message.error(response.data.message);
						}
					})
					.catch(error => {
						this.loginLoading = false
						console.log(error);
					});
			});
		}
	},
};
</script>

<style scoped>
.icon {
	width: 30px;
	height: 30px;
	vertical-align: -0.15em;
	fill: currentColor;
	overflow: hidden;
}
</style>

<style scoped lang="scss">
.thirdParty {
	text-align: center;
	.thirdParty_QQ {
	}
	.thirdParty_WX {
		margin-left: 20px;
	}
}

/* /deep/.el-input__inner:focus{
        color:#0080ff !important;
    } */
/deep/.el-input__inner {
	padding: 0 30px !important;
	border: 1px solid #ccc !important;
}
/deep/.el-input__prefix {
	color: #c0c4cc !important;
}
.login {
	width: 100%;
	min-height: 100%;
	background: url('../assets/bg.png') no-repeat center;
	background-size: cover;
	position: absolute;
}
.login-line {
	width: 80px;
	height: 1px;
	background: #0080ff;
}
.register {
	color: #0080ff;
	margin: 0 5px;
}
.el-button {
	color: #0080ff;
	border: 1px solid #0080ff;
}
.login-left {
	flex: 1;
}
.login-inpu-box {
	margin-top: 10%;
}
.login-right {
	flex: 1;
	display: flex;
	justify-content: flex-end;
	align-items: center;
}
.login_logo {
	width: 100%;
	cursor: pointer;
}
.login_logo img {
	width: 100px;
}
.login-tab {
	margin-top: 8%;
}
.login-tab ul {
	// width: 340px;
	margin: 0 auto;
	font-size: 0;
	margin-top: 30px;
	position: relative;
	justify-content: center;
}
.login-tab ul li {
	// width: 155px;
	height: 37px;
	display: inline-block;
	text-align: center;
	line-height: 32px;
	cursor: pointer;
	font-size: 34px;
	color: #707070;
	font-weight: 100;
	vertical-align: top;
	border-bottom: 2px solid transparent;
}
.login-tab p {
	font-size: 34px;
	color: #707070;
}
.login-left-box {
	width: 500px;
}
.right-img {
	width: 498px;
	height: 452px;
}
.login-box {
	width: 100%;
	height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
	// margin-top: 10%;
}
@media (max-width: 1366px) {
	.login-left-box {
		width: 400px;
		margin: 0 auto;
	}
	.login-box {
		width: 100%;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.right-img {
		width: 420px;
		height: 374px;
		margin-left: 3%;
	}
	.login-right {
		flex: 1;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.login-tab {
		margin-top: 8%;
	}
	.login-tab ul {
		// width: 340px;
		margin: 0 auto;
		font-size: 0;
		position: relative;
	}
	.login-tab ul li {
		// width: 155px;
		height: 37px;
		display: inline-block;
		text-align: center;
		line-height: 32px;
		cursor: pointer;
		font-size: 26px;
		color: #707070;
		font-weight: 100;
		vertical-align: top;
		border-bottom: 2px solid transparent;
	}
	.login-tab p {
		font-size: 26px;
		color: #707070;
	}
}
.login-tab ul li:first-child {
	/*border-right: 1px solid #cacaca;*/
	padding: 0 13px 0 0;
	margin-right: 20px;
}

.active-tab {
	color: #0080ff !important;
	border-bottom: 2px solid #0080ff !important;
	padding-bottom: 5px !important;
	// width: 150px !important;
	padding-right: 10px !important;
}
.el-button--primary {
	background-color: #0080ff !important ;
	border-color: #0080ff !important;
	color: #fff !important;
}
el-input:focus {
	border: 1px solis #0080ff;
}
.lang-box{ 
	display: flex;
	justify-content: space-between;
	align-items: center;
}
</style>
